import { faSlidersH } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, HoverCard } from "@mantine/core";

import { CompactMultiSelect, TeamsTierUpsell } from "@components";
import { AddYourCodeUpsell } from "@components/AddYourCodeUpsell";
import { useRepos } from "@hooks";

export interface RepoSelectorProps {
  reposFilter: string[];
  setReposFilter: (reposFilter: string[]) => void;
  hasTeamsTier: boolean;
  showUpsell?: boolean;
}
export const RepoSelector: React.FC<RepoSelectorProps> = ({
  reposFilter,
  setReposFilter,
  hasTeamsTier,
  showUpsell,
}) => {
  const { data: repos } = useRepos();

  const showPopover = !hasTeamsTier || showUpsell;

  if (showPopover) {
    return (
      <HoverCard withArrow shadow="sm" width={hasTeamsTier ? 200 : 320}>
        <HoverCard.Dropdown p="md">
          {hasTeamsTier ? (
            <AddYourCodeUpsell incentive="filter by project" />
          ) : (
            <TeamsTierUpsell />
          )}
        </HoverCard.Dropdown>
        <HoverCard.Target>
          <div>
            <Button
              leftIcon={<FontAwesomeIcon icon={faSlidersH} />}
              data-testid="RepoSelectorButton"
              disabled
              compact
            >
              <span data-testid="RepoSelectorButtonText">All projects</span>
            </Button>
          </div>
        </HoverCard.Target>
      </HoverCard>
    );
  }

  return (
    <CompactMultiSelect
      options={repos ? repos.map((repo) => repo.name ?? "") : []}
      selectedItems={reposFilter}
      onChange={(repos) => setReposFilter(repos)}
      searchable={true}
      selectAll={true}
      moveSelectedToTop={true}
      data-testid="overview-repo-selector"
      popoverProps={{ position: "bottom-end", width: 300 }}
    >
      <Button
        compact
        leftIcon={<FontAwesomeIcon icon={faSlidersH} />}
        data-testid="RepoSelectorButton"
      >
        <span data-testid="RepoSelectorButtonText">
          {reposFilter.length === 1
            ? reposFilter[0]
            : reposFilter.length === 0
            ? `All projects`
            : `${reposFilter.length} projects`}
        </span>
      </Button>
    </CompactMultiSelect>
  );
};
